export default __webpack_public_path__ + "20dff09.png";